import React from 'react';
import { useReveal } from '../hooks/useReveal';

const SOCIALS = [
  {
    name: 'LinkedIn',
    icon: 'fa-linkedin',
    url: 'https://www.linkedin.com/in/dhruvin-patel88/',
  },
  {
    name: 'GitHub',
    icon: 'fa-github',
    url: 'https://github.com/dhruvin88',
  },
  {
    name: 'Twitter',
    icon: 'fa-twitter',
    url: 'https://twitter.com/dhruvin88',
  },
  {
    name: 'Instagram',
    icon: 'fa-instagram',
    url: 'https://www.instagram.com/dhruvin88/',
  },
  {
    name: 'Facebook',
    icon: 'fa-facebook',
    url: 'https://www.facebook.com/dhruvinp',
  },
];

export default function Contact() {
  const ref = useReveal(0.12);

  return (
    <>
      <section className="section contact" id="contact" ref={ref}>
        <div className="container">
          <div className="section__header">
            <span className="label reveal">Get In Touch</span>
            <h2 className="section-title reveal reveal-delay-1">
              Let's work together
            </h2>
          </div>

          <p className="contact__lead reveal reveal-delay-2">
            Whether you have an opportunity, a project idea, or just want to
            connect — my inbox is always open.
          </p>

          <a
            href="mailto:dhruvinp895@gmail.com"
            className="contact__email-link reveal reveal-delay-3"
          >
            dhruvinp895@gmail.com
          </a>

          <nav
            className="contact__socials reveal reveal-delay-4"
            aria-label="Social links"
          >
            {SOCIALS.map(s => (
              <a
                key={s.name}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                className="contact__social"
                aria-label={s.name}
              >
                <span className="contact__social-icon">
                  <i className={`fa ${s.icon}`} aria-hidden="true" />
                </span>
                {s.name}
              </a>
            ))}
          </nav>
        </div>
      </section>

      <footer className="footer">
        <p>
          © {new Date().getFullYear()} Dhruvin Patel &nbsp;·&nbsp; Designed &amp;
          built with care
        </p>
      </footer>
    </>
  );
}
